import React, { useEffect } from 'react'
import CustomLoader from 'components/CustomLoader'

const isDarkThemeActive = () => {
	if (typeof window === 'undefined') return false

	if (document.documentElement.getAttribute('data-theme') === 'dark') return true

	try {
		return window.localStorage.getItem('erp_theme_mode') === 'dark'
	} catch (error) {
		return false
	}
}

const ContentOverlayLoader = ({ active, text, style, offsetY = 0, logo }) => {
	const useDarkOverlay = isDarkThemeActive()

	useEffect(() => {
		if (!active) return undefined

		const prevBodyOverflow = document.body.style.overflow
		const prevHtmlOverflow = document.documentElement.style.overflow

		document.body.style.overflow = 'hidden'
		document.documentElement.style.overflow = 'hidden'

		return () => {
			document.body.style.overflow = prevBodyOverflow
			document.documentElement.style.overflow = prevHtmlOverflow
		}
	}, [active])

	if (!active) return null

	return (
		<div
			style={{
				position: 'fixed', // Se mantiene fijo aunque hagas scroll
				top: 0,
				left: 0,
				width: '100vw',
				height: '100vh',
				backgroundColor: useDarkOverlay
					? 'rgba(32, 33, 36, 0.8)'
					: 'var(--theme-overlay-bg, transparent)',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				zIndex: 9999, // Asegura que esté por encima de todo
				backdropFilter: 'blur(4px)', // Opcional: desenfoca lo que hay detrás
			}}
		>
			<CustomLoader text={text} logo={logo} />
		</div>
	)
}

export default ContentOverlayLoader
